import { render, staticRenderFns } from "./GetCoupon.vue?vue&type=template&id=1f6f3008&scoped=true&"
import script from "./GetCoupon.vue?vue&type=script&lang=ts&"
export * from "./GetCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./GetCoupon.vue?vue&type=style&index=0&id=1f6f3008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f3008",
  null
  
)

export default component.exports